export default __webpack_public_path__ + "6a0981aa6d757913e3f73676b93c2a39.svg";